"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const checkForNull_1 = __importDefault(require("./checkForNull"));
function getFullAddress(address) {
    if ((0, lodash_1.isNil)(address))
        return 'N/A';
    const { street1, street2, city, state, zip } = address;
    const streetAddress = (0, lodash_1.compact)([
        (0, checkForNull_1.default)(street1),
        (0, checkForNull_1.default)(street2),
    ]).join(' ');
    return `${streetAddress}, ${city}, ${state}, ${zip}`;
}
exports.default = getFullAddress;
